import { Reveal, Overline } from "./Reveal";

const QUOTES = [
  {
    quote:
      "Lodge & Retreat Partners have become an extension of our team. Our guests walk in to a beautifully prepared arrival, dine on food that feels like theirs, and leave restored. One conversation, everything handled.",
    author: "Villa Owner",
    location: "Wānaka",
  },
  {
    quote:
      "As a property manager I need one accountable partner — not five suppliers. They protect our standards and add real revenue on top. It's changed how we operate.",
    author: "Boutique Property Manager",
    location: "Queenstown Lakes",
  },
  {
    quote:
      "From the fire lit on arrival to the seasonal dinner our chef prepared, every detail felt effortless. The kind of stay you remember years later.",
    author: "Guest, private lodge stay",
    location: "United Kingdom",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="relative bg-surface py-24 md:py-32 border-y border-white/10"
      data-testid="testimonials"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal>
          <Overline>Kind Words</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif font-light text-ink text-3xl md:text-5xl lg:text-6xl leading-[1.05] max-w-3xl">
            From guests who&apos;ve <em className="italic text-metallic-gold">stayed</em>
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {QUOTES.map((q, i) => (
            <Reveal key={q.author} delay={i * 0.08}>
              <div
                data-testid={`testimonial-${i}`}
                className="bg-surface p-8 md:p-10 h-full flex flex-col"
              >
                <span className="font-serif text-6xl text-gold/40 leading-none">“</span>
                <p className="mt-2 font-serif italic text-lg md:text-xl text-ink/85 leading-relaxed">
                  {q.quote}
                </p>
                <div className="mt-8 pt-6 border-t border-white/10">
                  <p className="font-sans text-sm text-ink">{q.author}</p>
                  <p className="font-sans text-[0.7rem] tracking-[0.2em] uppercase text-gold mt-1">
                    {q.location}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
